export default __webpack_public_path__ + "static/media/JoshPic.b0748521.JPG";